// extracted by mini-css-extract-plugin
export default {"table-cell":"table-cell--gb8fr","single-line":"single-line--bib9C","multi-line":"multi-line--MxgaP"};